module.exports = __webpack_public_path__ + "static/media/logo.a5676e59.svg";